module.exports = __webpack_public_path__ + "static/media/CarolineBrownlee-resume.89c0208e.pdf";